import { PopoverPassThrough } from "primeng/popover";

export const addTabPopoverPtOptions: PopoverPassThrough = {
    root: {
        style: {
            marginTop: "0",
            borderRadius: "6px",
        },
    },
    content: {
        style: {
            margin: "0",
            padding: "0.5rem",
            fontSize: "var(--p-azara-fonts-font-size-mm)",
            borderRadius: "6px",
            border: "1px solid var(--p-azara-grey-600)",
            color: "var(--p-azara-grey-600)",
            fontWeight: "300",
        },
    },
};
